module.exports = __webpack_public_path__ + "static/media/icon.21745e6d.png";